import { useDownloadReport } from 'shared/widgets/Notification/hooks/useDownloadReport';
import { NotificationPopperListItemFile } from 'shared/widgets/Notification/NotificationPopper/NotificationPopperListItem/components/NotificationPopperListItemFile/NotificationPopperListItemFile';
import { Notification, NotificationBodyReport } from 'types/embedded/notification';

import { NotificationPopperListItemReportPrimary } from './NotificationPopperListItemReportPrimary';

type Props = {
  notification: Notification<NotificationBodyReport>;
  onSuccess: () => void;
  dataId: string;
};

export const NotificationPopperListItemReport: React.FC<Props> = ({
  notification,
  onSuccess,
  dataId,
}) => {
  const {
    exportType,
    fileUrl,
    createdAt,
    reportPeriod: { from: periodFrom, to: periodTo },
  } = notification.body.content;

  const downloadReport = useDownloadReport({ notificationId: notification.id, fileUrl, onSuccess });

  return (
    <NotificationPopperListItemFile
      createdAt={createdAt}
      dataId={dataId}
      notification={notification}
      onDownload={downloadReport}
      primary={
        <NotificationPopperListItemReportPrimary
          exportType={exportType}
          periodFrom={periodFrom}
          periodTo={periodTo}
        />
      }
    />
  );
};
